import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import LeftToolbarComponent from '../../UI/Toolbar/LeftToolbar';
import Logo from '../../UI/Toolbar/LeftToolbar/Logo';
import LeftToolbarItems from '../ToolbarItems';
import UniversityLogo from '../ToolbarItems/universityLogo/universityLogo';
import { routes } from '../../../utilities/constants';

class LeftToolbar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      leftList,
      page,
      pathname,
      isTop,
      user,
      formatType,
      appType,
      universityPlan,
      LinkComponent,
      ImageComponent,
      organizationIdentity,
    } = this.props;

    const routesToCheck = [
      routes.DRIVE,
      routes.ACCOUNT,
      routes.SUPPORT,
      routes.BILLINGS,
      routes.IRIS,
      routes.LEARNING,
    ];
    const isPathIncluded =
      pathname && routesToCheck.some((route) => pathname.includes(route));
    return (
      <LeftToolbarComponent
        page={page}
        pathname={pathname}
        user={user}
        formatType={formatType}
      >
        <Logo
          pathname={pathname}
          isTop={isTop}
          appType={appType}
          LinkComponent={LinkComponent}
        />
        {isPathIncluded && universityPlan && (
          <UniversityLogo
            universityPlan={universityPlan}
            organizationIdentity={organizationIdentity}
          />
        )}
        {leftList && (
          <LeftToolbarItems
            list={leftList}
            pathName={pathname}
            trigger={this.handleItemClick}
            formatType={formatType}
            appType={appType}
            LinkComponent={LinkComponent}
            ImageComponent={ImageComponent}
          />
        )}
      </LeftToolbarComponent>
    );
  }
}

LeftToolbar.propTypes = {
  page: propTypes.string,
  leftList: propTypes.objectOf(
    propTypes.oneOf([propTypes.string, propTypes.object]),
  ).isRequired,
  pathname: propTypes.string.isRequired,
  isTop: propTypes.bool.isRequired,
  user: propTypes.objectOf(propTypes.object),
};

LeftToolbar.defaultProps = {
  user: null,
};

LeftToolbar.defaultProps = {
  page: 'editor',
};

export default LeftToolbar;
